import React from 'react';
import {useTariff} from 'contexts/Tariff';

import './AreaInput.scss';

const AreaInput = () => {
  const tariffAPI = useTariff();
  const {squareMeters} = tariffAPI.tariffState;

  return (
    <div
      className={`area-input__wrapper ${
        squareMeters ? 'area-input__wrapper_filled' : ''
      }`}
    >
      <input
        className="area-input"
        placeholder="Укажите площадь ванной, м²"
        type="number"
        onChange={e => {
          tariffAPI.setSquareMeters(e.target.value);
        }}
        value={squareMeters}
      />
    </div>
  );
};

export default AreaInput;
